
      if (import.meta.env.PROD) {
        document.addEventListener('contextmenu', function(e) {
          e.preventDefault();
        });
        
        // Disable F12, Ctrl+Shift+I, Ctrl+U
        document.addEventListener('keydown', function(e) {
          if (e.key === 'F12' || 
              (e.ctrlKey && e.shiftKey && e.key === 'I') ||
              (e.ctrlKey && e.key === 'u')) {
            e.preventDefault();
          }
        });
      }
    